import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@features/analytics/api/dashboard.api';

export const dashboardKeys = {
  all: ['dashboard'] as const,
  stats: () => [...dashboardKeys.all, 'stats'] as const,
};

export function useDashboardStats() {
  return useQuery({
    queryKey: dashboardKeys.stats(),
    queryFn: dashboardApi.stats,
    // Aggregates move slowly; no need to refetch on every mount.
    staleTime: 60_000,
  });
}
